import styled from 'styled-components/macro';

import { Flex } from 'components/styled/Flex';

export const CustomCardContainer = styled(Flex)<{ margin?: string }>`
  flex-wrap: wrap;
  margin-bottom: 1.5rem;

  @media only screen and (min-width: 569px) {
    > div:not(:last-child) {
      margin: ${({ theme, margin }) =>
        margin ? margin : `0 ${theme.spacing.one_2} ${theme.spacing.one_2} 0`};
    }
  }

  @media only screen and (max-width: 568px) {
    justify-content: center;
  }
`;

export const CustomCardItem = styled(Flex)<{ maxWidth?: string; height?: string }>`
  flex-flow: column;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.white};

  ${({ maxWidth }) => maxWidth && `min-width: ${maxWidth}; `}
  ${({ height }) => height && `height: ${height}; `}

  > svg {
    width: 100%;
    height: 3.125rem;
  }

  > img {
    max-height: 3.125rem;
    object-fit: contain;
  }

  @media only screen and (max-width: 568px) {
    margin: ${({ theme }) => `${theme.spacing.one} 0 0 0`};
  }
`;
